import { useSelector } from "react-redux"
import styled from "styled-components"

const Container = styled.button`
    display: flex;
    align-items: center;
    gap: 10px;

    span{
        font-size: var(--font-size-sm);
        font-size: 12px;
        font-weight: var(--font-weight-lg);
    }


`
const FiyatOnerBtn = ({handleClick}) => {

    const {theme} = useSelector(state => state.layout)

  return (
    <Container onClick={handleClick}>
        <svg width="16" height="14" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 0.75H1.5C0.947715 0.75 0.5 1.19772 0.5 1.75V7.75C0.5 8.30228 0.947715 8.75 1.5 8.75H10C10.5523 8.75 11 8.30228 11 7.75V1.75C11 1.19772 10.5523 0.75 10 0.75Z" stroke={theme === "dark" ? "#F4F4F4": "#3D3D3B"} stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M5.75 6.25C6.57843 6.25 7.25 5.57843 7.25 4.75C7.25 3.92157 6.57843 3.25 5.75 3.25C4.92157 3.25 4.25 3.92157 4.25 4.75C4.25 5.57843 4.92157 6.25 5.75 6.25Z" stroke={theme === "dark" ? "#F4F4F4": "#3D3D3B"} stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3.5 11.25H12.5C12.7652 11.25 13.0196 11.1446 13.2071 10.9571C13.3946 10.7696 13.5 10.5152 13.5 10.25V5.25" stroke={theme === "dark" ? "#F4F4F4" : "#3D3D3B"} stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Fiyat Öner</span>

    </Container>
  )
}

export default FiyatOnerBtn